var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-snackbar',{staticClass:"global-snackbar",attrs:{"message":_vm.currentSnackbar.message,"action-text":_vm.currentSnackbar.actionText,"action-url":_vm.currentSnackbar.actionUrl,"has-close-button":_vm.currentSnackbar.showCloseButton},on:{"action":_vm.executeCurrentSnackbarAction,"close":_vm.nextSnackbar}})
}
var staticRenderFns = []

export { render, staticRenderFns }